import Vue from 'vue'
import Router from 'vue-router'
import Home from '../view/pc/Home.vue'
import Article from '../view/pc/Article.vue'
import Magazine from '../view/pc/Magazine.vue'
import AllMagazine from '../view/pc/AllMagazine.vue'
import Activity from '../view/pc/Activity.vue'
import AboutUs from '../view/pc/AboutUs.vue'
import Home_M from '../view/mobile/Home.vue'
import Article_M from '../view/mobile/Article.vue'
import AllMagazine_M from '../view/mobile/AllMagazine.vue'
import Magazine_M from '../view/mobile/Magazine.vue'
import Activity_M from '../view/mobile/Activity.vue'
import AboutUs_M from '../view/mobile/AboutUs.vue'
import VueRouter from 'vue-router'
Vue.use(Router)

const routesP =  [
  {
    path:'/',
    component:Home
  },
  {
    path:'/article',
    component:Article
  },
  {
    path:'/magazine',
    name:'/magazine',
    component:Magazine
  },
  {
    path:'/allMagazine',
    component:AllMagazine
  },
  {
    path:'/activity',
    component:Activity
  },
  {
    path:'/aboutus',
    component:AboutUs
  }
]
const routesM =  [
  {
    path:'/',
    component:Home_M
  },
  {
    path:'/article',
    component:Article_M
  },
  {
    path:'/allMagezine',
    component:AllMagazine_M
  },
  {
    path:'/magazine',
    name:'/magazine',
    component:Magazine_M
  },
  {
    path:'/activity',
    component:Activity_M
  },
  {
    path:'/aboutus',
    component:AboutUs_M
  }
]
var routes = [];
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  routes = routesM
}
else {
  routes = routesP
}
const router = new VueRouter({
  routes,
  mode:'history'
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js